var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.121 17.804c2.09842-1.1861 4.46858-1.8077 6.879-1.804 2.5 0 4.847.655 6.879 1.804m-3.879-7.804c0 .7956-.3161 1.5587-.8787 2.1213s-1.3257.8787-2.1213.8787-1.5587-.3161-2.12132-.8787c-.56261-.5626-.87868-1.3257-.87868-2.1213 0-.79565.31607-1.55871.87868-2.12132.56262-.56261 1.32572-.87868 2.12132-.87868s1.5587.31607 2.1213.87868.8787 1.32567.8787 2.12132zm6 2c0 1.1819-.2328 2.3522-.6851 3.4442-.4523 1.0919-1.1152 2.084-1.9509 2.9198-.8358.8357-1.8279 1.4986-2.9198 1.9509-1.092.4523-2.2623.6851-3.4442.6851s-2.35222-.2328-3.44415-.6851-2.08408-1.1152-2.91981-1.9509c-.83573-.8358-1.49866-1.8279-1.95096-2.9198-.45229-1.092-.68508-2.2623-.68508-3.4442 0-2.38695.94821-4.67613 2.63604-6.36396s3.97701-2.63604 6.36396-2.63604c2.3869 0 4.6761.94821 6.364 2.63604 1.6878 1.68783 2.636 3.97701 2.636 6.36396z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.7dbe5834ed545e963b485a20d2bfc476.svg";
export { ForwardRef as ReactComponent };